import brandTheme from '../../../../Assets/Styles/brandTheme'

const { colors } = brandTheme()

const commonOptions = {
  title: {
    text: '',
  },
  colors: [colors.secondary],
  credits: false,
  legend: {
    enabled: false,
  },
  allowDecimals: false,
  rangeSelector: {
    selected: 1,
  },
  navigator: {
    enabled: false,
  },
  tooltip: {
    enabled: false,
  },
}

export const chartOptionsScanByOsGraph = {
  ...commonOptions,
  chart: {
    type: 'bar',
    height: '70%',
  },
  yAxis: {
    title: {
      text: '',
    },
    max: 100,
    min: 0,
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
        format: `{y} %`,
      },
    },
  },
}

export const chartOptionsByCityGraph = {
  ...commonOptions,
  chart: {
    type: 'column',
    height: '70%',
  },
  yAxis: {
    title: {
      text: '',
    },
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
        format: `{y}`,
      },
    },
  },
}

export const headers = {
  id: 'ID',
  countryCode: 'Country Code',
  city: 'City',
  flyerCode: 'Flyer Code',
  mobileOs: 'Mobile Os',
  ipAddress: 'IP Address',
  createdAt: 'Date',
  redirectUrl: 'Redirect URL',
}



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignPerforming/options.js